import $ from 'jquery';
import Utils from '../utils';
import GaTracking from '../core/components/ga-tracking';
var QuantityInputAction;
(function (QuantityInputAction) {
    QuantityInputAction["Dec"] = "dec";
    QuantityInputAction["Inc"] = "inc";
})(QuantityInputAction || (QuantityInputAction = {}));
export default class QuantityInput {
    static $input = $('.js__quantity-input');
    static $button = $('.js__quantity-input-button');
    static init() {
        this.setInitialInputValues();
        this.setFocus();
        this.$input.on('change', event => {
            const $input = $(event.currentTarget);
            this.handleInputChange($input);
        });
        this.$button.on('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
                const action = $(event.currentTarget).data('focus-id');
                sessionStorage.setItem('productCountLastAction', action);
            }
        });
        this.$button.on('click', event => {
            const $button = $(event.currentTarget);
            const $input = $button.siblings('.js__quantity-input');
            this.updateInputValue($input, $button.data('action'));
        });
    }
    static setInitialInputValues() {
        this.$input.each((index, element) => {
            const $input = $(element);
            $input.data('initial-value', $input.val());
        });
    }
    static setFocus() {
        const lastAction = sessionStorage.getItem('productCountLastAction');
        sessionStorage.removeItem('productCountLastAction');
        const $button = $(`.js__checkout-summary-delete-item-btn[data-focus-id="${lastAction}"], .js__quantity-input-button[data-focus-id="${lastAction}"]`);
        $button.trigger('focus');
    }
    static handleInputChange($input) {
        if (!Number($input.val())) {
            $input.val(1);
        }
        $input
            .siblings(`.js__quantity-input-button[data-action="${QuantityInputAction.Dec}"]`)
            .toggleClass('disabled', Number($input.val()) === 1)
            .prop('disabled', Number($input.val()) === 1);
        if ($input.data('submit-on-change')) {
            this.pushDataLayerEvent($input);
            Utils.contentLoader($('.js__checkout-wrapper'), true);
            $input.closest('form').trigger('submit');
        }
    }
    static updateInputValue($input, action) {
        const currentValue = Number($input.val());
        const newValue = action === QuantityInputAction.Dec ? currentValue - 1 : currentValue + 1;
        $input.val(newValue).trigger('change');
    }
    static pushDataLayerEvent($input) {
        const initialValue = Number($input.data('initial-value'));
        const currentValue = Number($input.val());
        const productData = $input.data('product-info');
        if (!productData || initialValue === currentValue) {
            return;
        }
        const event = currentValue < initialValue ? 'removeFromCart' : 'addToCart';
        if (productData) {
            const data = {
                ...productData,
                event,
                ecommerce: {
                    ...productData.ecommerce,
                    add: {
                        ...productData.ecommerce.add,
                        products: productData.ecommerce.add.products.map((product) => ({
                            ...product,
                            quantity: currentValue,
                        })),
                    },
                },
            };
            GaTracking.pushDataLayer(data);
        }
    }
}
